// document-set-service.ts
// API service for set-based document fetching (personal / shared).
import { fetchData } from './data-service';
import { PaginatedResponse } from '../types';
import { DOCUMENTS_ENDPOINT } from './utils/api-consts';

export type SetType = 'personal' | 'shared';

export interface DocumentLight {
    id: string;
    title: string;
    description: string | null;
    documentTypeId: string;
    createdAt: string;
    updatedAt: string;
    rowVersion: string | null;
}

export interface GetDocumentsParams {
    setType: SetType;
    page?: number;
    pageSize?: number;
    search?: string;
    documentTypeId?: string;
    ownerId?: string;
}

/**
 * Fetch documents filtered by set type.
 * GET /api/documents?setType=personal|shared&page=&pageSize=&search=&ownerId=
 */
export async function getDocumentsBySet(
    params: GetDocumentsParams
): Promise<PaginatedResponse<DocumentLight>> {
    const { setType, page = 1, pageSize = 20, search, documentTypeId, ownerId } = params;

    const query = new URLSearchParams({
        setType,
        page: String(page),
        pageSize: String(pageSize),
    });

    if (search) query.set('search', search);
    if (documentTypeId) query.set('documentTypeId', documentTypeId);
    if (ownerId) query.set('ownerId', ownerId);

    return fetchData<PaginatedResponse<DocumentLight>>(
        `${DOCUMENTS_ENDPOINT}?${query.toString()}`
    );
}
